import React from 'react';
import { useHistory } from 'react-router-dom';
import { type ToastType, useGlobalToast } from '../contexts/globalToast';

const RedirectWithToast: React.FC<{
  to: string;
  message: string;
  type?: ToastType;
}> = ({ to, message, type = 'info' }) => {
  const { setContents: setToastContents } = useGlobalToast();
  const history = useHistory();
  const hasRedirected = React.useRef(false);

  React.useEffect(() => {
    if (!hasRedirected.current) {
      setToastContents(message, type);
      history.push(to);
      hasRedirected.current = true;
    }
  }, [setToastContents, message, type, history, to]);

  return null;
};

export default RedirectWithToast;
